// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.

import angular, { ITemplateCacheService } from "angular"
import { ICompileService, IScope } from "angular"

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class SearchController {
   $scope: any
   config: ConfigService
   citationTrail: any
   moreFacets: any
   searchTabs: any


   constructor($scope: any, config: ConfigService, citationTrail: CitationTrailService, moreFacets: MoreFacetsService, searchTabs: any) {
      this.selectTab = this.selectTab.bind(this)
      this.$scope = $scope
      this.config = config
      this.citationTrail = citationTrail
      this.moreFacets = moreFacets
      this.searchTabs = searchTabs
      this.$scope.citationTrail = this.citationTrail.scope
      this.$scope.displayCitationTrail = config.data.results.displayCitationTrail
      this.$scope.shouldDisplayCitationTrail = (doc: any) => config.data.results.displayCitationTrail && (this.citationTrail.hasCitedBy(doc) || this.citationTrail.hasCites(doc))
      this.$scope.selectedTab = this.searchTabs.search
      this.$scope.searchTabs = this.searchTabs
      this.$scope.sections = {}
      this.$scope.selectTab = this.selectTab
      this.citationTrail.on('citationsTriggered', () => {
         return this.$scope.selectedTab = this.searchTabs.citationTrail
      })

      this.citationTrail.on('citationsReset', () => {
         return this.$scope.selectedTab = this.searchTabs.search
      })
      this.generateCustomSection()

   }



   selectTab(tab: any) {
      return this.$scope.selectedTab = tab
   }

   

   private generateCustomSection(): void {
      const displayOrder = this.config.data.customSections.displayOrder  // example:  ['az-search', 'topic-summary', 'custom-sections']
      this.$scope.sections = {}
      for (let i = 0; i < displayOrder.length; i++) {
         const element = displayOrder[i]
         // add the class name to the template so it nows what order it should be
         // the order is according to the config, and sets a class. The class in main.css sets the order in the flexbox column  
         this.$scope.sections[element] = `order${i + 1} ${element}`
      }
   }
}

SearchController.$inject = ['$scope', 'configService', 'citationTrailService', 'moreFacetsService', '$searchTabs']

angular.module('summonApp.controllers')
   .controller('SearchCtrl', SearchController)
